import {
  kategoriTindakanOptions,
  jenisAnestesiOptions,
  golonganTindakanOptions,
  ruangOperasiOptions
  } from "@/data/helper.js";
export let data = {
  title: "Data Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Input Data Operasi", active: true }
  ]
};
export let today = new Date();
import { getTime } from './helper.js';
export let time = getTime(today.getHours(), today.getMinutes());
export let upperFormLeft = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Operasi",
        type: "date",
        placeholder: "Pilih tanggal operasi",
        name: "tanggal",
        value: today,
        optional: true,
        additional: "",
        disabled: true,
        colwidth: "6"
      },
      {
        label: "Mulai Operasi",
        type: "time",
        placeholder: "",
        name: "sign_in",
        value: time,
        optional: true,
        additional: "",
        disabled: true,
        colwidth: "3"
      },
      {
        label: "Selesai Operasi",
        type: "time",
        placeholder: "",
        name: "sign_out",
        value: time,
        optional: true,
        additional: "",
        disabled: true,
        colwidth: "3"
      }
    ]
  }
];
export let upperForm = [
  {
    colnum: 5,
    columns: [

      {
        label: "Jam Mulai",
        type: "time",
        placeholder: "",
        name: "time_start",
        value: "",
        additional: "",
        colwidth: "2"
      },
      {
        label: "Jam Selesai",
        type: "time",
        placeholder: "",
        name: "time_end",
        value: "",
        additional: "",
        colwidth: "2"
      },
      {
        label: "Durasi Operasi",
        type: "addon-right",
        addon: "Menit",
        placeholder: "",
        name: "durasi",
        value: 0,
        mandatory: true,readonly:true,
        additional: "",
        colwidth: "2"
      },
      {
        label: "Ruang Operasi",
        type: "select",
        placeholder: "",
        name: "id_operasi_ruangan",
        value: 0,
        mandatory: true,
        additional: "",
        colwidth: "3",
        options: ruangOperasiOptions
      }
    ]
  }
];
export let leftForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Operator",
        type: "select",
        placeholder: "Pilih Dokter Operator",
        name: "id_dokter_operator",
        value: 0,
        mandatory: true,
        additional: "",
        disabled: true,
        readonly: true,
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Anestesi",
        type: "select",
        placeholder: "Pilih Dokter Anestesi",
        name: "id_dokter_anestesi",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Dokter Referal",
  //       type: "select",
  //       placeholder: "Pilih Dokter Referal",
  //       name: "id_dokter_referal",
  //       value: 0,
  //       mandatory: true,
  //       additional: "",
  //       options: []
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Instrumen",
        type: "select",
        placeholder: "Pilih Perawat Instrumen",
        name: "id_perawat_instrumen",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Anestesi",
        type: "select",
        placeholder: "Pilih Perawat Anestesi",
        name: "id_perawat_anestesi",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Sirkuler",
        type: "select",
        placeholder: "Perawat Sirkuler 1",
        name: "id_perawat_sirkuler_1",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        placeholder: "Perawat Sirkuler 2",
        name: "id_perawat_sirkuler_2",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        placeholder: "Perawat Sirkuler 3",
        name: "id_perawat_sirkuler_3",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        placeholder: "Perawat Sirkuler 4 (Opsional)",
        name: "id_perawat_sirkuler_4",
        value: 0,
        optional: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        placeholder: "Perawat Sirkuler 5 (Opsional)",
        name: "id_perawat_sirkuler_5",
        value: 0,
        optional: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Kategori Tindakan",
        type: "select",
        placeholder: "Pilih Kategori Tindakan",
        name: "kategori_tindakan",
        value: "",
        mandatory: true,
        multiple: false,
        options: kategoriTindakanOptions,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Golongan Tindakan",
        type: "select",
        placeholder: "Pilih Golongan Tindakan",
        name: "golongan_tindakan",
        value: "",
        mandatory: true,
        multiple: false,
        options: golonganTindakanOptions,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jenis Anestesi",
        type: "select",
        placeholder: "Pilih Jenis Anestesi",
        name: "jenis_anastesi",
        value: "",
        options: jenisAnestesiOptions,
        mandatory: true
      }
    ]
  }
];
export let rightForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa pra operasi",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "diagnosa_pra_operasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa post operasi",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "diagnosa_post_operasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Komplikasi",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "komplikasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 3,
    columns: [
      {
        label: "Jumlah Pendarahan",
        type: "addon-right",
        addon: "cc",
        placeholder: "",
        name: "jumlah_pendarahan",
        value: "",
        mandatory: true,
        additional: "",
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "jaringan_PA",
        type: "radio",
        label: "Jaringan PA",
        options: [
          { label: 'Ya', value: "1" },
          { label: 'Tidak', value: "0" }
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Asal Jaringan",
        type: "text",
        placeholder: "",
        name: "asal_jaringan",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
},{
    colnum: 1,
    columns: [
      {
        label: "Implant",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "implant",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
];
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6
      }
    ]
  }
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps"
  }
];
